var React = require('react');

function Component (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M64.8895 2.89262C72.7753 5.62235 79.5356 9.66158 86.4203 14.2514C89.1379 16.027 97.9131 24.3721 101.961 28.3228C105.458 37.4146 104.826 49.8652 99.4745 58.4999C88.9164 75.5368 77.2682 82.8507 57.2039 78.3919C44.1106 75.4823 31.9209 68.1528 19.1152 64.1511C11.9871 61.9235 3.37476 57.1632 1.59661 49.2885C0.432904 44.135 0.57147 33.0313 3.29195 28.3228C6.43122 22.8894 12.0332 18.0236 16.2331 13.4037L16.256 13.3785C19.4242 9.89347 22.1883 6.85298 26.9137 5.94423C40.7101 3.29109 50.7577 -1.99914 64.8895 2.89262Z","fill":"currentColor"}));
}

Component.defaultProps = {"width":"105","height":"80","viewBox":"0 0 105 80","fill":"none"};

module.exports = Component;

Component.default = Component;
